import React from 'react'
import styled from 'styled-components';
import InfoIcon from '@mui/icons-material/Info';

const Container = styled.span`
display: ${props=> props.focused ? 'flex' : 'none'};
align-items: center;
font-size: 10px;
color: #fff;
margin-left: 5px;
svg {
  font-size: 1rem;
  color: #C21010;
  margin-right: 5px;
}
`;

const ErrorContainer = ({focused, error}) => {
  return (
    <Container focused={focused}>
      <InfoIcon/> {error}
    </Container>
  )
}

export default ErrorContainer